import React from 'react';
import './Bakelitepump.css';

const Bakelitepump = () => {
  return (
    <div className="Specialp-container">
      <h2 className="Specialp-heading">FEATURES</h2>

      <div className="Specialp-card">


        <ul className="Specialp-list" data-aos="fade-down">
          <li> High response variable displacement pump saving 25%~50% power.</li>
          <li>Excellent corrosion resistance and wear resistance with specialized material tube.</li>
          <li> The material pipeline oil cooling device ensures stable and accurate temperature control</li>
          <li>exhaust function for opening the mold.</li>
          <li>Two sets of mold temperature control interface, using computer high precision control.</li>

        </ul>
      </div>
    </div>
  );
};

export default Bakelitepump;
